import { Checkbox } from '@mui/material';
import { forwardRef, ReactNode } from 'react';
import { ControllerRenderProps } from 'react-hook-form';

import { FormControlLabel } from './FormCheckbox.styled';

const FormCheckbox = forwardRef<
  HTMLLabelElement,
  Pick<ControllerRenderProps, 'onChange'> & {
    label: ReactNode;
    checked?: boolean;
    disabled?: boolean;
  }
>(({ label, onChange, checked, disabled }, ref) => {
  return (
    <FormControlLabel
      label={label}
      ref={ref}
      control={<Checkbox disableRipple onChange={onChange} checked={checked} disabled={disabled} />}
    />
  );
});

export default FormCheckbox;
